import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  OnInit,
} from '@angular/core';
import {Widget} from '@ispm/widgets/decorator/widget.decorator';
import {IWidgetItem} from '@ispm/widgets/interfaces/widget-item.interface';
import {FormGroup} from "@angular/forms";
import {get,cloneDeep,isEqual,set} from "lodash";
import {
  ActionMode,
  IFormLoaderPayload
} from "@ispm/widgets/components/form-loader/interfaces/form-loader.payload.interface";
import {filter, map} from "rxjs/operators";
import {modalResponse} from "@ispm/layout/constants/modal-responses.enum";
import {Observable} from "rxjs";
import {TunnelResult} from "@ispm/layout/classes/tunnel-result";
import {FormHandlerService} from "@ispm/dynamic-form/services/form-handler.service";
import {DynamicFormItem} from "@ispm/dynamic-form/classes/dynamic-form-item.class";
import {isarray} from "formula";
import {buttonTypes} from "@ispm/shared/components/button/button.component";

@Component({
  selector: 'gen-form-loader',
  templateUrl: './form-loader.component.html',
  styleUrls: ['./form-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('FormLoader')
export class FormLoaderComponent implements OnInit, IWidgetItem<IFormLoaderPayload> {
  // private static DEFAULT_CSS_CLASSES: string = 'full-size-item hide-invalid-flag ';
  widgetUpdateValueCallback: (value) => void;
  public listenToDataChange = true;
  public inputConfig: [DynamicFormItem];
  private childFormId:string;
  public widgetConfigPayload: IFormLoaderPayload;
  public formData:any;
  public searchObject: any;
  public restForm: boolean = false;
  public newCaseTunnel: Observable<TunnelResult>;
  public widgetFormInstance: FormGroup;
  private _valid: boolean;
  private prev:any
  public ModalLoaderTunnelName ='LUNG_PACK_YEAR_CALCULATOR';
  public disabled: boolean;
  set widgetConfig(widgetConfig) {
    this.widgetConfigPayload = widgetConfig.widgetPayload;
    this.childFormId=this.widgetConfigPayload.actions[0].childFormId;
    if(this.widgetConfigPayload.formConfig && isarray(this.widgetConfigPayload.formConfig))
    this.inputConfig = [
      Object.assign({},
        DynamicFormItem.builder(
          this.widgetConfigPayload.formConfig[0].label || '',
          this.widgetConfigPayload.formConfig[0].name||'default',
          this.widgetConfigPayload.formConfig[0].type
        ).setCssClass(this.widgetConfigPayload.formConfig[0].cssClass)
          .setRequired(this.widgetConfigPayload.formConfig[0].required)
          .setPlaceholder(this.widgetConfigPayload.formConfig[0].placeholder)
          .setEditable(this.widgetConfigPayload.formConfig[0].editable)
          .setDefault(this.widgetConfigPayload.formConfig[0].defaultValue))

    ];
    this.inputConfig[0]['min']=this.widgetConfigPayload.formConfig[0].min;
    this.inputConfig[0]['regex']=this.widgetConfigPayload.formConfig[0].regex?this.widgetConfigPayload.formConfig[0].regex:null;
    this.inputConfig[0]['attributes']= {'[forceFormMode]': true};
    this.widgetConfigPayload.actions.forEach((action)=>{
     this._formHandler.getForm(action.childFormId).take(1).publish().connect();
   })
  }
  set widgetData(widgetData: any) {
    if(!widgetData){
      return;
    }
    this._changeDetector.detach();
    this.formData = widgetData;
    if(this.widgetConfigPayload.disableMode){
      let flag=false;
      this.widgetConfigPayload.disableMode.forEach(({key,value})=>{
        if(get(this.formData, key) === value)
         flag=true
      })
      flag?this.widgetConfigPayload.disabled=true:this.widgetConfigPayload.disabled=false;
    }
    this._changeDetector.reattach();
    this._changeDetector.markForCheck();
  }

  constructor(private _changeDetector: ChangeDetectorRef,
              private _formHandler: FormHandlerService
  ) {
  }

  ngOnInit() {
    if (!this.formData) {
      this.formData = {};
    };

    if (this.widgetFormInstance) {
      this.disabled = get(this.widgetFormInstance, 'disabled', false);
    }
  }
  formChange(form) {
    this.prev=this.formData;
    if(isEqual(this.prev,form)) // && !this._valid)
      return;
    this.formData = form;
    this.widgetUpdateValueCallback(this.formData);
  }
  onFormInit(data){
    // this.widgetUpdateValueCallback.apply(this, [{ 'form': data}, true]);
  }
  // validateChange(isValid:boolean){
  //   this._valid=isValid;
  //   return;
  // }
  /**
   * handling button click event
   * @param i
   * @param mode
   */
  openPopUpModal(i:number,mode:string) {
    let payloaddata=this.composeParamToPick(i);
switch (mode) {
  case ActionMode.openPopup :{
    if(this.widgetConfigPayload.actions[i].childFormId){

      this.newCaseTunnel = this.popupDynamicFormModal(
        this.widgetConfigPayload.actions[i].childFormtitle || '',
        this.widgetConfigPayload.actions[i].childFormId,
        payloaddata, // formData
        'Confirm',
        'Cancel'
      ).pipe(
        filter((data: any) => data.status === modalResponse.approve && data.payload.isValid),
        map(data => data)
      );

      this.newCaseTunnel.take(1).subscribe(data => {
        if ((data.payload.responseType === 1)) {
          this.setParamsToSet(data.payload.formData)
        }
      });
    }
    break;
  };
  default :{
    break;
  }
}

  }

  /**
   * This function is to map parent df form data to child form data
   * @param i
   */
  composeParamToPick(i:number){
    let formData= this.formData;
    let dataToBePicked:any={};
    this.widgetConfigPayload.actions[i].paramsToPick.forEach(params=>{
      dataToBePicked[params.dest]=get(formData,params.source,null);
    })
    return dataToBePicked;
  }

  /**
   * Once Form data from child is received we run this function to map and pass data to parent
   * @param formData
   */
  setParamsToSet(formData){
    let parentFormData=cloneDeep(this.formData) || {} ;
    this.widgetConfigPayload.paramsToPick.forEach(params=>{
      if(formData.hasOwnProperty((params.source))) {
        parentFormData[params.dest] = get(formData, params.source, null);
      }
    });
    this.formData= Object.assign({}, parentFormData);
    this._changeDetector.markForCheck();

    // this._changeDetector.detectChanges();
    this.widgetUpdateValueCallback(this.formData);
  }

  /**
   * to open child form in popup mode
   * @param title
   * @param formId
   * @param formData
   * @param approveBtn
   * @param declineBtn
   */
  popupDynamicFormModal(title: string, formId: string, formData: any, approveBtn?: string, declineBtn?: string) {
    return this._formHandler.popupDynamicFormModal(title, formId, formData, approveBtn, declineBtn, null, this.ModalLoaderTunnelName, null, false);
  }

}
